import { render, staticRenderFns } from "./Enrollment.vue?vue&type=template&id=4d8e87b2&"
import script from "./Enrollment.vue?vue&type=script&lang=js&"
export * from "./Enrollment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports